/* eslint-disable class-methods-use-this */
import { EntityDto } from 'services/dto';

import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import {
  CreateCustomer,
  Customer,
  GetCustomerInvite,
  PagedCustomerDto,
  UpdateCustomer,
} from './dto/customer';

class CustomerService {
  public async getAll(
    pagedFilterAndSortedRequest: PagedCustomerDto
  ): Promise<PagedResultDto<Customer>> {
    const result = await http.get('api/services/app/Customer/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }
  public async get(entityDto: EntityDto<string | number>): Promise<Customer> {
    const result = await http.get('api/services/app/Customer/Get', { params: entityDto });
    return result.data.result;
  }

  public async getByUserId(entityDto: EntityDto<string | number>): Promise<Customer> {
    const result = await http.get('api/services/app/Customer/GetByUserId', { params: entityDto });
    return result.data.result;
  }

  public async delete(entityDto: EntityDto<string>) {
    const result = await http.delete('api/services/app/Customer/Delete', { params: entityDto });
    return result.data;
  }

  public async create(customer: CreateCustomer) {
    const result = await http.post('api/services/app/Customer/Create', customer);
    return result.data;
  }

  public async update(customer: UpdateCustomer) {
    const result = await http.put('api/services/app/Customer/Update', customer);
    return result.data.result;
  }

  public async getInvite(request: GetCustomerInvite) {
    const result = await http.get('api/services/app/CustomerInvite/GetCustomerInvite', {
      params: request,
    });
    return result.data.result;
  }
}

export default new CustomerService();
